import store from '../store/index.js'
export default {
	rand: Math.random(),
	
	
	// 白名单不要验证token的  axios请求和拦截器使用
	whiteListApi: ['/api/getAuction', '/api/getTargetsArea', '/api/getTargets', '/api/getNotice', '/api/getPicCode',
		'/api/getAppRegCode', '/api/getAppEmailCode', '/api/appRegUser','/api/getAppCode','/api/appUserLogin','/api/appLoginUser','/aps/getTargetinfo','/api/mechanisms'
	],
	
	// 图片地址前部分
	url: 'https://paimai-1304461808.file.myqcloud.com/',
	
	// 上传图片地址
	uploadUrl: 'https://api.haopaiwang.net/api/upload',
	headers: {
		Authorization: "Bearer " + store.state.user.token,
	},
	
}